// Used to prevent circle dependency.

// eslint-disable-next-line import/prefer-default-export
export const filterBarWidth = '30rem';
